import './Query2.scss'
import React, {Component} from 'react'
import {withRouter} from '../../helpers/withRouter'
import {withTranslation} from 'react-i18next'
import {ReportService, SessionStorageService} from '../../services'
import {
  Page,
  PageBottomBar,
  PageContent,
  PageFooter,
  PageHeader,
  PageToolbar,
  PageTopBar,
  PdfModal
} from '../../layouts/Private/components'
import {Button, Col, Form, Pagination, Row, Spin} from 'antd'
import {SearchBox2, SearchCard} from './components'
import {animatePageContentPromise, getQueryDetailsPromise, getQueryFirstPagePromise} from './promises'
import sadSmileyImage from './no-results-bg.png'
import rutFormatter from '../../helpers/formatRut'
import {getSearchesPromise} from './../AdminSearch/promises'
import SearchCardHis from './components/SearchCard/SearchCardHis'
import moment from 'moment'

class Query2 extends Component {
  state = {
    breadcrumbs: this.getBreadcrumbs(),
    isAdvancedSearchFiltersVisible: false,
    isLoadingFirst: false,
    isLoadingOthers: false,
    query: '',
    queryId: '',
    queryResults: [],
    historyResults: [],
    historyResultsCurrentPage: 1,
    historyResultsFromNum: 0,
    historyResultsPerPage: 10,
    historyResultsTotalNum: -1,
    showModalPdf: false,
    pdfSource: '',
    loadingPdf: false,
    rutSearch: ''
  }

  async componentDidMount() {
    this.handlePaginationChange(1)
  }

  getBreadcrumbs() {
    const { t } = this.props

    const breadcrumbs = [
      { title: t('messages.aml.query'), icon: 'file-search', link: '/consulta2' }
    ]

    return breadcrumbs
  }

  async handleChange(e) {
    const { queryId, isSearch } = this.state
    const newValue = e.target.value

    if (newValue === '') {
      await this.setState({ query: '', rutSearch: '' })

      if (queryId || isSearch) {
        await this.setState({
          queryId: '',
          queryResults: [],
          isSearch: false,
          totalResults: undefined,
        })

        await SessionStorageService.delete('latest_Query')
        await SessionStorageService.delete('latest_QueryId')
        await SessionStorageService.delete('latest_QueryResultsCurrentPage')
        await SessionStorageService.delete('latest_QueryResultsFromNum')
        await SessionStorageService.delete('latest_QueryResultsTotalNum')

        animatePageContentPromise.shrink()
      }

      return
    }

    const { rut, rutFull } = this.formatRut(newValue)

    await this.setState({ query: rut, rutSearch: rutFull })
  }

  async handleQuery(text) {
    if (text !== '') {
      const { queryFiltersPersonType, queryFiltersSearchScope, queryResultsPerPage, subclientId, historyResultsPerPage } = this.state

      // const isSubclientSelected = this.validateSubclientSelection()

      await this.setState({ isLoadingFirst: true, isLoadingOthers: true, queryResults: [], query: text })

      // if (isSubclientSelected) {
      const queryFirstPage = await getQueryFirstPagePromise(text, subclientId, queryResultsPerPage, queryFiltersPersonType, queryFiltersSearchScope)

      let results = queryFirstPage.results
      if(queryFirstPage.size === 0) {
          results.push({formatRut: text})
      }

      await this.setState({
        queryId: queryFirstPage.searchId,
        queryResults: results,
        queryResultsCurrentPage: 1,
        isLoadingFirst: false,
        loadingPdf: true,
        totalResults: queryFirstPage.size,
        isSearch: true
      })

      if (queryFirstPage.size > 0) {
        //Mostrar pdf
        this.downloadPdf(queryFirstPage.results[0]);

        getQueryDetailsPromise(queryFirstPage.results[0].id)
      } else {
        this.handleDownloadCertificate()
      }

      this.handlePaginationChange(1, historyResultsPerPage, true)

      this.setState({ isLoadingOthers: false })
    }
  }

  async handleSearch(text) {
    if (text !== '') {
      return this.handleQuery(text)
    }
  }

  async handlePaginationChange(from, size, isSearch=false) {
    const { historyResultsPerPage } = this.state
    const fromNum = (from - 1) * historyResultsPerPage

    await animatePageContentPromise.grow(historyResultsPerPage)

    this.setState({ isLoadingOthers: true, historyResultsFromNum: fromNum, isSearch })

    let today = moment().format('DD/MM/YYYY');;
    let todayLessMonth = moment().subtract(1, 'month').format('DD/MM/YYYY');

    getSearchesPromise(fromNum, from === 1 && isSearch ? historyResultsPerPage-1 : historyResultsPerPage, {hasReport: 'S', modo: 'ONLINE', optDates: 'RANGE', fromDate: todayLessMonth, toDate: today}).then(queryResults => {
      this.setState({
        historyResults: queryResults.records,
        historyResultsCurrentPage: from,
        historyResultsTotalNum: queryResults.total,
        isLoadingOthers: false
      })
    })
  }

  handlePersonMouseOver(e) {
    const person = e.target

    person.className = 'person-card mouseover'

    window.setTimeout(() => {
      person.className = 'person-card'
    }, 500)
  }

  handlePersonMouseOut(e) {
    const person = e.target

    person.className = 'person-card mouseout'

    window.setTimeout(() => {
      person.className = 'person-card'
    }, 500)
  }

  closeHandlerPdfModal() {
    this.setState({
      showModalPdf: false
    })
  }

  async handleDownloadCertificate() {
    const { queryId } = this.state;
    //window.open(apiConfig.urlAml + '/pdfUNIQUE.pdf?bId=' + queryId)

    this.setState({
      loadingPdf: true
    })
    //Llamar endpoint y obtener base64
    ReportService.pdfToObj('/pdfSearchResults', { id: decodeURIComponent(queryId) }, null, 'report.pdf').then(pdf => {
      this.setState({
        showModalPdf: true,
        pdfSource: pdf.data,
        loadingPdf: false
      })
    })
  }

  handleOnChangeSubclient(subclientId) {
    this.setState({ subclientId })
  }

  handleScrollToTop(duration) {
    const scrollStep = -window.scrollY / (duration / 15)
    const scrollInterval = setInterval(function () {
      if (window.scrollY !== 0) {
        window.scrollBy(0, scrollStep)
      } else clearInterval(scrollInterval)
    }, 15)
  }

  downloadPdf(person) {
    this.setState({
      loadingPdf: true
    })
    ReportService.pdfToObj('/pdfCompliance.pdf', { id: decodeURIComponent(person.id) }).then(pdf => {
      this.setState({
        showModalPdf: true,
        pdfSource: pdf.data,
        loadingPdf: false
      })
    })
  }


  async downloadPdfHis(record){
    if (record.certificados !== null && record.certificados.length > 0) {
      this.handlePDFReport(record.id, record.certificados[0].pdf)
    }
  }

  async handlePDFReport(searchId, pdf) {
    const obj = await ReportService.pdfToObj('/certificate', { searchId, pdf }, null, 'report.pdf')
    this.setState({
      showModalPdf: true,
      pdfSource: obj.data
    })
  }

  formatRut(rut) {
    let rutVal = rutFormatter.format(rut);

    let rutFull
    let rutD;
    let dv;

    rut = rutVal;
    if (rutVal && rutVal.length > 0) {
      var isValid = rutFormatter.validate(rutVal);
      if (isValid) {
        rutFull = rutFormatter.clean(rutVal);
        rutD = rutFull.slice(0, rutFull.length - 1);
        dv = rutFull.slice(-1);
      }
    }

    return {
      rut,
      rutFull,
      rutD,
      dv,
    };
  }

  render() {
    const { currentUser, t } = this.props
    const { getFieldDecorator } = this.props.form
    const { breadcrumbs, isAdvancedSearchFiltersVisible, isLoadingFirst, isLoadingOthers, query, queryResults, historyResults, historyResultsCurrentPage, historyResultsPerPage, historyResultsTotalNum, showModalPdf, pdfSource, loadingPdf, totalResults, isSearch } = this.state

    return (
      <div style={{ position: 'relative' }}>
        <PageTopBar breadcrumbs={breadcrumbs} />
        <Page>
          <PageHeader
            title={t('messages.aml.query')}
            description={t('messages.aml.queryPageDescription')}
            icon="file-search"
          >
          </PageHeader>
          <PageToolbar additionalClassName={isAdvancedSearchFiltersVisible ? 'is-advanced-search' : ''}>
            <Form.Item>
              {getFieldDecorator('query')(<SearchBox2 onChange={this.handleChange.bind(this)} onSearch={this.handleSearch.bind(this)} currentQuery={query} loading={isLoadingFirst || loadingPdf} />)}
            </Form.Item>
          </PageToolbar>
          <PageContent className={(!historyResults.length && !isLoadingFirst && !isLoadingOthers && historyResultsTotalNum === -1) && 'empty'}>
            <div className="page-content-inner" style={{ marginBottom: 20 }}>
              <div className="table-headers">
                <Row>
                  <Col xs={8}>
                    {t('messages.aml.personalIdentification')}
                  </Col>
                  <Col xs={8}>
                    {t('messages.aml.date')}
                  </Col>
                  <Col xs={8}>
                    {t('messages.aml.downloadPDF')}
                  </Col>
                </Row>
              </div>
              { historyResultsCurrentPage === 1 && isSearch &&
                (
                  isLoadingFirst ?
                  <Spin size={'large'} />
                  :
                  queryResults.map((person, index) => <SearchCard key={index} person={person} currentUser={currentUser} onClick={totalResults === 0 ? this.handleDownloadCertificate.bind(this) : this.downloadPdf.bind(this)} loading={loadingPdf} />)
                )
              }
              {isLoadingOthers ?
                <Spin size={'large'} />
                :
                (historyResultsTotalNum === 0 && query.length) ?
                  <div className="zero-results">
                    <br />
                    <div align="center" style={{ height: '200px' }}><img src={sadSmileyImage} alt="" /></div>
                    <br /><br /><br /><br /><br /><br />
                    <div align="center" style={{ fontSize: '1.8em' }}>{t('messages.aml.queryNoResult')}.</div>
                    <div align="center">{t('messages.aml.queryNoResultDownloadPDFPhrase')} :</div>
                    <br />
                    <div>
                      <Button disabled={loadingPdf} type="primary" size="large" icon={loadingPdf ? "loading" : "file-pdf"} onClick={this.handleDownloadCertificate.bind(this)}>
                        {t('messages.aml.viewPdf')}
                      </Button>
                    </div>
                  </div>
                  :
                  historyResultsTotalNum > -1 &&
                    isLoadingOthers ?
                    <Spin size={'large'} />
                    :
                    historyResults.map((person, index) => <SearchCardHis key={index} person={person} currentUser={currentUser} onClick={this.downloadPdfHis.bind(this)} />
                    )
              }

            </div>
          </PageContent>
          <PageFooter>
            {historyResultsTotalNum > 0 &&
              <Pagination
                key={Math.floor(Math.random() * 100000000)}
                current={historyResultsCurrentPage}
                onChange={this.handlePaginationChange.bind(this)}
                pageSize={historyResultsPerPage}
                total={historyResultsTotalNum}
              />
            }
          </PageFooter>
          {showModalPdf && <PdfModal closeHandler={this.closeHandlerPdfModal.bind(this)} pdfSource={pdfSource} embeded={true} isObj={true}/>}
        </Page>
        <PageBottomBar breadcrumbs={breadcrumbs} />
        {/* { isSelectedPersonVisible && ReactDOM.createPortal(<ProfilePage currentPerson={ selectedPerson } currentUser={ currentUser } isTransition />, document.body) } */}
      </div>
    )
  }
}

const WrappedTimeRelatedForm = Form.create({ name: 'query' })(Query2)

export default withRouter(withTranslation()(WrappedTimeRelatedForm))
